const mockData = {
  services: {
    hands: [
      {
        name: 'Gel Manicure',
        description: 'Long-lasting gel polish with a glossy finish that lasts up to 3 weeks.',
        price: '$50',
        duration: '60 min'
      },
      {
        name: 'Strengthening (Hard Gel / Builder Gel)',
        description: 'Reinforce and protect natural nails with durable gel overlay.',
        price: '$60',
        duration: '75 min'
      },
      {
        name: 'Nail Extensions',
        description: 'Beautiful extended nails customized to your preferred length and shape.',
        price: '$70',
        duration: '90 min'
      },
      {
        name: 'Fill (Nail Correction)',
        description: 'Maintain your extensions with professional fill and correction.',
        price: '$60',
        duration: '60 min'
      },
      {
        name: 'Classic Polish Manicure',
        description: 'Traditional manicure with high-quality polish in your favorite color.',
        price: '$35',
        duration: '45 min'
      },
      {
        name: 'Single Nail Repair',
        description: 'Quick fix for broken or damaged nails.',
        price: '$5',
        duration: '15 min'
      }
    ],
    feet: [
      {
        name: 'Gel Pedicure',
        description: 'Luxurious pedicure with long-lasting gel polish and foot massage.',
        price: '$40',
        duration: '75 min'
      },
      {
        name: 'Classic Polish Pedicure',
        description: 'Complete pedicure with traditional polish and relaxing foot treatment.',
        price: '$35',
        duration: '60 min'
      },
      {
        name: 'Foot Cleaning',
        description: 'Deep cleansing treatment for healthy, refreshed feet.',
        price: '$20',
        duration: '30 min'
      }
    ],
    extras: [
      {
        name: 'Nail Art',
        description: 'Custom artistic designs ranging from simple accents to elaborate artwork.',
        price: '$1 - $2',
        duration: '15-45 min'
      },
      {
        name: 'French / Ombre',
        description: 'Classic French tips or stunning ombre gradient effects.',
        price: '$10',
        duration: '20 min'
      },
      {
        name: "Removal of Other Technician's Work",
        description: 'Full removal service for sets applied elsewhere before a new application.',
        price: '$10',
        duration: '30 min'
      },
      {
        name: 'Removal of My Work',
        description: 'Gentle removal of previously applied sets done at KC Nails UKR.',
        price: '$0',
        duration: '30 min'
      }
    ]
  },
  gallery: [
    {
      url: 'https://customer-assets.emergentagent.com/job_45bf91d8-03ab-4216-8d9b-87abe81b5417/artifacts/38262qtk_image.png',
      alt: 'Artistic nail design with spider web details'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_45bf91d8-03ab-4216-8d9b-87abe81b5417/artifacts/vbotewp2_WhatsApp%20Image%202025-11-24%20at%2013.56.57_1ad73614.jpg',
      alt: 'Elegant purple burgundy gel manicure'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_45bf91d8-03ab-4216-8d9b-87abe81b5417/artifacts/57shmzig_WhatsApp%20Image%202025-11-24%20at%2013.56.58_e299981c.jpg',
      alt: 'Stunning red long nail extensions'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_45bf91d8-03ab-4216-8d9b-87abe81b5417/artifacts/3jvd41bu_WhatsApp%20Image%202025-11-24%20at%2013.56.58_da177985.jpg',
      alt: 'Professional nail care service in progress'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_45bf91d8-03ab-4216-8d9b-87abe81b5417/artifacts/x38ah1gu_WhatsApp%20Image%202025-11-24%20at%2013.56.57_f6dbf0da.jpg',
      alt: 'KC Nails UKR contact and services'
    },
    {
      url: 'https://images.unsplash.com/photo-1519014816548-bf5fe059798b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxuYWlsJTIwYXJ0fGVufDB8fHx8MTc2MDA0Mjg1NXww&ixlib=rb-4.1.0&q=85',
      alt: 'Pink artistic manicure'
    },
    {
      url: 'https://images.unsplash.com/photo-1720343409646-960f6dcccae3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxuYWlsJTIwYXJ0fGVufDB8fHx8MTc2MDA0Mjg1NXww&ixlib=rb-4.1.0&q=85',
      alt: 'Luxury hands with rings and nail art'
    },
    {
      url: 'https://images.unsplash.com/photo-1571290274554-6a2eaa771e5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxuYWlsJTIwYXJ0fGVufDB8fHx8MTc2MDA0Mjg1NXww&ixlib=rb-4.1.0&q=85',
      alt: 'Colorful creative nail art'
    },
    {
      url: 'https://images.pexels.com/photos/704815/pexels-photo-704815.jpeg',
      alt: 'Artistic green nail designs'
    },
    {
      url: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtYW5pY3VyZXxlbnwwfHx8fDE3NjAwNDI4NjF8MA&ixlib=rb-4.1.0&q=85',
      alt: 'Professional salon atmosphere'
    },
    {
      url: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtYW5pY3VyZXxlbnwwfHx8fDE3NjAwNDI4NjF8MA&ixlib=rb-4.1.0&q=85',
      alt: 'Sophisticated dark manicure with gold ring'
    },
    {
      url: 'https://images.unsplash.com/photo-1641814250010-9887d86eedfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtYW5pY3VyZXxlbnwwfHx8fDE3NjAwNDI4NjF8MA&ixlib=rb-4.1.0&q=85',
      alt: 'Elegant manicured hands with ring'
    }
  ],
  about: {
    story: "At KC Nails UKR in Calgary, we believe that nail care is an art form. Founded by a passionate nail artist with years of experience, we specialize in creating unique, personalized designs that reflect each client's individual style and personality.",
    mission: "Our mission is to provide exceptional nail services for Calgary clients in a relaxing, welcoming environment. We're constantly exploring new techniques and staying ahead of trends to offer you the most innovative and beautiful nail designs.",
    values: [
      {
        title: 'Creativity & Innovation',
        description: 'Always thinking of different ways for people to express themselves through nail art.'
      },
      {
        title: 'Quality & Precision',
        description: 'Using only premium products and meticulous attention to detail in every service.'
      },
      {
        title: 'Client-Centered Care',
        description: 'Your satisfaction and comfort are our top priorities.'
      },
      {
        title: 'Calgary Community',
        description: 'Proud to support local events and treat neighbours across the city with elevated nail artistry.'
      }
    ]
  },
  promotions: [
    {
      title: 'First-Time Client Offer',
      discount: '20% OFF',
      description: 'Welcome to KC Nails UKR!',
      details: [
        'Valid on all services',
        'For new clients only',
        'Mention this offer when booking'
      ],
      validUntil: null
    },
    {
      title: 'Refer a Friend',
      discount: '10% OFF',
      description: 'Share the beauty with someone special!',
      details: [
        'Refer a friend and both receive 10% OFF your next visit',
        'No limit on referrals',
        'Valid on all services'
      ],
      validUntil: null
    }
  ],
  testimonials: [
    {
      name: 'Sarah Johnson',
      rating: 5,
      review: 'Absolutely amazing work! The nail art is stunning and lasts for weeks. KC is so talented and creative!',
      date: 'March 2025'
    },
    {
      name: 'Emily Chen',
      rating: 5,
      review: 'Best nail salon experience ever! The attention to detail is incredible. I always leave feeling pampered and beautiful.',
      date: 'February 2025'
    },
    {
      name: 'Maria Rodriguez',
      rating: 5,
      review: 'KC is a true artist! She brings my nail ideas to life and always adds her creative touch. Highly recommend!',
      date: 'January 2025'
    }
  ],
  contact: {
    phone: '+1 587 404 2400',
    email: 'kcnailsukr@gmail.com',
    address: 'Calgary, Alberta (studio visits by appointment only)',
    serviceArea: [
      'Downtown Calgary & Beltline',
      'Mission & Elbow Park',
      'Inglewood & Ramsay',
      'West Calgary & Signal Hill',
      'Surrounding communities in the Calgary metro area'
    ],
    hours: [
      'Monday - Friday: 9:00 AM - 7:00 PM',
      'Saturday: 10:00 AM - 6:00 PM',
      'Sunday: By Appointment'
    ]
  }
};

export default mockData;
